const chartColors = {
  annotationLabelBackground: 'rgba(255, 255, 255, 0.7)',
  gray: '#666666',
  darkGray: '#333333',
  gridLine: '#dddddd',
  primary: '#36C799',
};

const chart = {
  fontFamily: 'Roboto, sans-serif',
};

const chartTitle = {
  color: chartColors.darkGray,
};

const axisTitle = {
  color: chartColors.gray,
  fontSize: '12px',
};

const axisLabel = {
  style: {
    color: chartColors.gray,
  },
};

export default {
  chart,
  chartTitle,
  axisTitle,
  chartColors,
  axisLabel,
};
